<template>
	<div class="study">
		<publicHeader @child-event="parentEvent"></publicHeader>
		<personalHeader :myInfo="myInfo"></personalHeader>
		
		<div class="personal bg_gray">
			<div class="w1200 flex">
				<personalNav :current="current"></personalNav>
				<div class="personal_r bg_white radius8">
					<div class="personal_title mab20">
						<i class="f20px cl_dark mar10">账号保护</i>
						<span class="cl_gray mal10"></span>
					</div>
					<div class="personal_div">
						<div class="personal_item" v-if="myInfo.is_test == 0">
							<p class="personal_item_l f16px cl_gray"><span class="inline">手机</span><i class="inline">：</i></p>
							<div class="personal_item_r">
								<span class="personal_item_name f16px">{{myInfo.phone == ''||myInfo.phone == null ? '未绑定手机' : myInfo.phone}}</span>
								<router-link to="/phone" class="cl_blue">{{myInfo.phone == ''||myInfo.phone == null ? '绑定手机>' : '更换手机>'}}</router-link>
							</div>
						</div>
						<div class="personal_item" v-if="myInfo.is_test == 0">
							<p class="personal_item_l f16px cl_gray"><span class="inline">绑定微信</span><i class="inline">：</i></p>
							<div class="personal_item_r">
								<span class="personal_item_name f16px">{{myInfo.wx_nickname == '' ? '未绑定微信' : myInfo.wx_nickname}}</span>
								<span class="cl_blue cur" @click="bindWx">{{myInfo.wx_nickname == '' ? '绑定微信>' : '更换微信>'}}</span>
							</div>
						</div>
						<div class="personal_item"  v-if="myInfo.phone != 0 && myInfo.name != null">
							<p class="personal_item_l f16px cl_gray"><span class="inline">密码</span><i class="inline">：</i></p>
							<div class="personal_item_r">
								<span class="personal_item_name f16px">******</span>
								<router-link to="/password" class="cl_blue">修改密码></router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<vfooter></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import vfooter from '../../components/footer.vue'
	import personalHeader from '../../components/personal_header.vue'
	import personalNav from '../../components/personal_nav.vue'
	export default {
	  name: 'personal_protect',
		components: {
			publicHeader,
			vfooter,
			personalHeader,
			personalNav,
		},
	  props: {
	    
	  },
		data () {
			return {
				myInfo: {},
				current: {
					navCur: 1,
					listCur: 2,
				},
				
			}
		},
		mounted() {
			
		},
		created() {
			
		},
		methods: {
			parentEvent (data) {
				this.myInfo = data;
			},
			bindWx () {
				// var url = "http://jy.jiheyun.com/wait_for";
				// var url = "http://test1.joy366.com/wait_for";
				var url = "http://www.joy366.com/wait_for";
				url = encodeURIComponent(url);
				// var appid = "wxc8e7e95bbff8174b";
				var appid = "wx8f41a3d953333118";
				var scope = "snsapi_login";
				var state = "2";
				if (this.myInfo.wx_unionid != null) {
					this.$messageBox.confirm('您已绑定微信，确定更换吗?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
					}).then(() => {
						window.open('https://open.weixin.qq.com/connect/qrconnect?appid=' + appid + '&redirect_uri=' + url + '&response_type=code&scope=' + scope + '&state=' + state, '_blank');
					}).catch(() => {
						
					});
				} else {
					window.open('https://open.weixin.qq.com/connect/qrconnect?appid=' + appid + '&redirect_uri=' + url + '&response_type=code&scope=' + scope + '&state=' + state, '_blank');
				}
			},
			
		},
	}
</script>

<style>
</style>
